import { useEffect, useRef } from "react";

const dimensionMaxMap = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1440px',
};

const useResponsiveHandler = (breakpoint, handler) => {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const responsiveHandler = (mql) => {
      handlerRef.current(mql.matches);
    };

    let mql;

    if (typeof window !== 'undefined') {
      const { matchMedia } = window;
      if (matchMedia && breakpoint && dimensionMaxMap[breakpoint]) {
        mql = matchMedia(`(max-width: ${dimensionMaxMap[breakpoint]})`);
        mql.addEventListener('change', responsiveHandler);

        responsiveHandler(mql);
      }
    }

    return () => {
      if (mql) {
        mql.removeEventListener('change', responsiveHandler);
      }
    };
  }, [breakpoint]);
};

export default useResponsiveHandler;
